// LALA-BRAIN-1 CLAUSE 2 — **HER JOURNAL SETTING, AS A LAW A GATE CAN RUN.**
//
// This module imports NOTHING, so `scripts/lala-brain-journal.mjs` RUNS it and the panel next to it
// stays hookless and callable. The pattern is `src/dailyLineSetting.js`'s, one preference over, and
// the shape is repeated rather than shared on that file's own precedent: two preferences that happen
// to have the same three states are still two decisions, and folding them would make one member
// control's copy change when the other one's did.
//
// **THREE STATES, NOT TWO** (R18). A boolean would collapse *we have not read her setting yet* into
// *it is off*, and on THIS control that would be the worst possible loading state: it would tell a
// member her journal is private from Lala while Lala can still read it.
export const JOURNAL_LALA_STATES = { ON: "on", OFF: "off", UNKNOWN: "unknown" };

/** What the panel draws, from what the route answered. `null` has not been read yet. */
export function journalLalaState(answer) {
  if (!answer || typeof answer !== "object") return JOURNAL_LALA_STATES.UNKNOWN;
  if (answer.on === true) return JOURNAL_LALA_STATES.ON;
  if (answer.on === false) return JOURNAL_LALA_STATES.OFF;
  return JOURNAL_LALA_STATES.UNKNOWN;
}

// **THE FACE SAYS WHAT IS; THE BUTTON SAYS WHAT A TAP DOES** — ITEM 7's law, and the reason the
// action is derived rather than written beside each state: a toggle labelled with the thing it is
// already showing is how a member turns off the thing she was trying to turn on.
export const JOURNAL_LALA_ACTIONS = { SHARE: "share", KEEP_PRIVATE: "keep-private" };

export function journalLalaAction(state) {
  if (state === JOURNAL_LALA_STATES.ON) return JOURNAL_LALA_ACTIONS.KEEP_PRIVATE;
  if (state === JOURNAL_LALA_STATES.OFF) return JOURNAL_LALA_ACTIONS.SHARE;
  // Unknown offers NO button. A control that cannot know what it would do must not offer to do it
  // (P4-4's ruling, and R44: refuse, never resolve).
  return "";
}

// The copy keys. They live here rather than in the panel so `scripts/item14-strings.mjs` finds them
// through the same census it runs over every other surface's keys.
export const JOURNAL_LALA_COPY = {
  [JOURNAL_LALA_STATES.ON]: "journal.lala.on",
  [JOURNAL_LALA_STATES.OFF]: "journal.lala.off",
  [JOURNAL_LALA_STATES.UNKNOWN]: "journal.lala.unknown",
};
export const JOURNAL_LALA_ACTION_KEYS = {
  [JOURNAL_LALA_ACTIONS.SHARE]: "journal.lala.share",
  [JOURNAL_LALA_ACTIONS.KEEP_PRIVATE]: "journal.lala.keepPrivate",
};

export function journalLalaCopy(state) {
  return JOURNAL_LALA_COPY[state] || JOURNAL_LALA_COPY[JOURNAL_LALA_STATES.UNKNOWN];
}

/**
 * **WHAT A TAP MEANS ON THE WIRE.** The route takes the DESIRED state rather than a verb, so a
 * double-tap is idempotent and a retry after a dropped answer cannot flip her back: `keep-private`
 * always means `{ on: false }`, however many times it arrives.
 */
export function journalLalaRequest(action) {
  if (action === JOURNAL_LALA_ACTIONS.KEEP_PRIVATE) return { on: false };
  if (action === JOURNAL_LALA_ACTIONS.SHARE) return { on: true };
  return null;
}
